module.exports = __webpack_public_path__ + "56f58f5a7ea69db7c86930a68009b994.png";